import React from 'react'
import PropTypes from 'prop-types'

const BASE_CLASSES = 'tw:relative tw:px-5 tw:py-3 tw:mb-4 tw:border tw:border-solid '
  + 'tw:rounded-md! tw:bg-ds-warning-lowest tw:text-ds-warning'

const WarningAlert = ({ children, className = '' }) => (
  <div className={`${BASE_CLASSES} ${className}`.trim()}>
    {children}
  </div>
)

WarningAlert.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

WarningAlert.defaultProps = {
  className: ''
}

export default WarningAlert
